export default __webpack_public_path__ + "images/5b63a29e2afc4eee2deb912b291be385-spd_header_image_mobile.webp";